// @flow
/** @jsx jsx */

import { Border } from '@zapier/theme';
import { Icon } from '@zapier/common-components';
import { css, jsx } from '@emotion/core';

import ZapMoverSection from 'app/zap-mover/components/FilterableZapsList/ZapMoverSection';
import { compareBySortOrderOrTitle } from 'app/common/CommonUtils';

import type {
  FolderType,
  OnChooseFolderType,
  OnChooseZapType,
} from 'app/zap-mover/types';

type Props = {
  folders: Array<FolderType>,
  isFiltered: boolean,
  isSingleSelect?: boolean,
  onChooseFolder: OnChooseFolderType,
  onChooseZap: OnChooseZapType,
};

const zapMoverZapsListCss = {
  border: `${Border.size.default} solid ${Border.color.default}`,
  borderRadius: `0 0 ${Border.radius.default} ${Border.radius.default}`,
  height: 300,
  overflow: 'auto',
};

const emptyCss = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
};

const ZapMoverZapsList = (props: Props) => {
  const isEmpty = props.folders.length === 0;

  if (isEmpty) {
    return (
      <div css={css(zapMoverZapsListCss, emptyCss)}>
        <div>
          <Icon color="steel" margin={{ bottom: 10 }} name="search" size={35} />
          <p>
            {props.isFiltered
              ? 'We couldn’t find any Zaps with that name.'
              : 'We couldn’t find any Zaps.'}
          </p>
        </div>
      </div>
    );
  } else {
    const isOpen = props.isFiltered || props.folders.length === 1;

    const commonProps = {
      isOpen,
      isSingleSelect: props.isSingleSelect,
      onChooseFolder: props.onChooseFolder,
      onChooseZap: props.onChooseZap,
    };

    const sharedFolders = props.folders
      .filter(folder => folder.isShared)
      // $FlowFixMe
      .sort(compareBySortOrderOrTitle);

    const privateFolders = props.folders
      .filter(folder => !folder.isShared)
      // $FlowFixMe
      .sort(compareBySortOrderOrTitle);

    return (
      <div css={zapMoverZapsListCss}>
        <ZapMoverSection
          {...commonProps}
          folders={privateFolders}
          key="private"
          title="Private Folders"
        />
        <ZapMoverSection
          {...commonProps}
          folders={sharedFolders}
          key="shared"
          title="Shared Folders"
        />
      </div>
    );
  }
};

export default ZapMoverZapsList;
